import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import { Page } from "types/dto/Page";

import { RequestContatosRealizados } from "types/request/RequestContatosRealizados";
import { ContatosRealizadosDTO } from "types/dto/GestaoCobrancaContatoDTO";
import { toast } from "react-hot-toast";

export const useGetContatosRealizados = (
  request: RequestContatosRealizados,
  deveBuscar: boolean
) => {
  const onError = () => {
    toast.error("Erro ao buscar histórico de contatos");
  };

  return useFetch<Page<ContatosRealizadosDTO>>({
    key: ["contatos-realizados", request.unidadeId, request.page, request.sort],
    url: api.gestaoCobranca.getContatosRealizados,
    params: request,
    enabled: deveBuscar,
    onError,
  });
};
